<div class="npdc-title">
  @if (label(); as label) {
    <h1>Edit label - {{ labelName() }}</h1>
  } @else {
    <h1>New label</h1>
  }

  <div class="npdc-title__actions">
    @if (form.pristine) {
      <a mat-flat-button type="button" routerLink="/label">Close</a>
    } @else {
      <a mat-button type="button" routerLink="/label">Close</a>
    }
  </div>
</div>

<form id="form" [formGroup]="form" (ngSubmit)="save()">
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <input required matInput formControlName="type" />
    </mat-form-field>
    <mat-hint>
      In use are “harvester” and “project”. For new types use only lowercase letters and British
      English.
    </mat-hint>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input required matInput formControlName="title" />
    </mat-form-field>
    <mat-hint>
      When the label has an abbreviation, use “[abbreviation] - [full title]”.<br />
      Example: "SUDARCO - Sustainable Development of the Arctic Ocean"
    </mat-hint>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>URL</mat-label>
      <input matInput formControlName="url" />
    </mat-form-field>
  </p>

  <p class="npdc-form-actions">
    <button mat-flat-button type="submit" [disabled]="form.pristine || form.invalid">Save</button>
    @if (label()) {
      <button mat-stroked-button type="button" (click)="delete()">Delete</button>
    }
  </p>
</form>

@if (label(); as label) {
  <mat-list>
    <mat-list-item>
      <div matListItemTitle>ID</div>
      <div matListItemLine>{{ label.id }}</div>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle>Created</div>
      <span matListItemLine
        >{{ label.created | date }}
        @if (label.createdBy | resolveUser | async; as user) {
          by {{ user.email }}
        }
      </span>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle>Modified</div>
      <span matListItemLine
        >{{ label.modified | date }}
        @if (label.modifiedBy | resolveUser | async; as user) {
          by {{ user.email }}
        }
      </span>
    </mat-list-item>
  </mat-list>
}
